// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withdrawRequestMainContainer {
    display: flex;
    flex-direction: column;
    gap: 2vh;
    width: 100%;
}

.withdrawRequestContainer {
    display: flex;
    width: 92%;
    padding: 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3.2vh;
    border-radius: 12px;
    border: 1px solid #2D2E33;
    background: #070F0F;
    margin-top: 7.5vh;
}

.requestWithdrawProfileInfo {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 2vh;
}

.profileInfoTitleContainer {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 2.2vh;
}

.withdrawRequestText {
    color: #FFF;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.profileTitleText {
    color: #858585;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
}

.profileValueText {
    color: #DFDFDF;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
}

.withdrawRequestBtnContainer {
    display: flex;
    padding: 20px 16px;
    justify-content: center;
    align-items: center;
    gap: var(--Gap-and-Padding-Positive-GapPadding-12, 12px);
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
    border-radius: 12px;
    background: #1E2727;
    backdrop-filter: blur(10px);
    cursor: pointer;
}

.withdrawRequestBtnText {
    color: #FF7B7B;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
}
.uploadAgainText{
    color: white;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
}

.underProgressText {
    color: #B8A771;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
    margin-top: -10px;
}

.nickNameContainer {
    margin-top: 20px;
    width: 111%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 10px;
}

.editNickNameText {
    color: #FFF;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 10px;
}

@media (max-width: 1640px) {
    .withdrawRequestText {
        font-size: 18px;
    }
    .profileTitleText {
        font-size: 18px;
    }
    .profileValueText {
        font-size: 18px;
    }
    .withdrawRequestBtnContainer {
        padding: 16px;
    }
    .withdrawRequestBtnText {
        font-size: 18px;
    }
}
@media (max-width: 1440px) {
    .withdrawRequestText {
        font-size: 16px;
    }
    .profileTitleText {
        font-size: 16px;
    }
    .profileValueText {
        font-size: 16px;
    }
    .withdrawRequestBtnContainer {
        padding: 14px;
    }
    .withdrawRequestBtnText {
        font-size: 16px;
    }
    .uploadAgainText {
        font-size: 16px;
    }
}
@media (max-width: 1280px) {
    .withdrawRequestText {
        font-size: 14px;
    }
    .profileTitleText {
        font-size: 14px;
    }
    .profileValueText {
        font-size: 14px;
    }
    .withdrawRequestBtnContainer {
        padding: 12px;
        border-radius: 10px;
    }
    .withdrawRequestBtnText {
        font-size: 14px;
    }
    .uploadAgainText {
        font-size: 14px;
    }
}
@media (max-width: 1024px) {
    .withdrawRequestText {
        font-size: 12px;
    }
    .profileTitleText {
        font-size: 12px;
    }
    .profileValueText {
        font-size: 12px;
    }
    .withdrawRequestBtnContainer {
        padding: 10px;
        border-radius: 8px;
    }   
    .withdrawRequestBtnText {
        font-size: 12px;
    }
    .uploadAgainText {
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/WithdrawRequest/WithdrawRequest.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,wDAAwD;IACxD,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".withdrawRequestMainContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 2vh;\n    width: 100%;\n}\n\n.withdrawRequestContainer {\n    display: flex;\n    width: 92%;\n    padding: 30px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 3.2vh;\n    border-radius: 12px;\n    border: 1px solid #2D2E33;\n    background: #070F0F;\n    margin-top: 7.5vh;\n}\n\n.requestWithdrawProfileInfo {\n    width: 100%;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 2vh;\n}\n\n.profileInfoTitleContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 2.2vh;\n}\n\n.withdrawRequestText {\n    color: #FFF;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.profileTitleText {\n    color: #858585;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-transform: capitalize;\n}\n\n.profileValueText {\n    color: #DFDFDF;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-transform: capitalize;\n}\n\n.withdrawRequestBtnContainer {\n    display: flex;\n    padding: 20px 16px;\n    justify-content: center;\n    align-items: center;\n    gap: var(--Gap-and-Padding-Positive-GapPadding-12, 12px);\n    align-self: stretch;\n    width: 100%;\n    box-sizing: border-box;\n    border-radius: 12px;\n    background: #1E2727;\n    backdrop-filter: blur(10px);\n    cursor: pointer;\n}\n\n.withdrawRequestBtnText {\n    color: #FF7B7B;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-transform: capitalize;\n}\n.uploadAgainText{\n    color: white;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-transform: capitalize;\n}\n\n.underProgressText {\n    color: #B8A771;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-transform: capitalize;\n    margin-top: -10px;\n}\n\n.nickNameContainer {\n    margin-top: 20px;\n    width: 111%;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 10px;\n}\n\n.editNickNameText {\n    color: #FFF;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    padding-bottom: 10px;\n}\n\n@media (max-width: 1640px) {\n    .withdrawRequestText {\n        font-size: 18px;\n    }\n    .profileTitleText {\n        font-size: 18px;\n    }\n    .profileValueText {\n        font-size: 18px;\n    }\n    .withdrawRequestBtnContainer {\n        padding: 16px;\n    }\n    .withdrawRequestBtnText {\n        font-size: 18px;\n    }\n}\n@media (max-width: 1440px) {\n    .withdrawRequestText {\n        font-size: 16px;\n    }\n    .profileTitleText {\n        font-size: 16px;\n    }\n    .profileValueText {\n        font-size: 16px;\n    }\n    .withdrawRequestBtnContainer {\n        padding: 14px;\n    }\n    .withdrawRequestBtnText {\n        font-size: 16px;\n    }\n    .uploadAgainText {\n        font-size: 16px;\n    }\n}\n@media (max-width: 1280px) {\n    .withdrawRequestText {\n        font-size: 14px;\n    }\n    .profileTitleText {\n        font-size: 14px;\n    }\n    .profileValueText {\n        font-size: 14px;\n    }\n    .withdrawRequestBtnContainer {\n        padding: 12px;\n        border-radius: 10px;\n    }\n    .withdrawRequestBtnText {\n        font-size: 14px;\n    }\n    .uploadAgainText {\n        font-size: 14px;\n    }\n}\n@media (max-width: 1024px) {\n    .withdrawRequestText {\n        font-size: 12px;\n    }\n    .profileTitleText {\n        font-size: 12px;\n    }\n    .profileValueText {\n        font-size: 12px;\n    }\n    .withdrawRequestBtnContainer {\n        padding: 10px;\n        border-radius: 8px;\n    }   \n    .withdrawRequestBtnText {\n        font-size: 12px;\n    }\n    .uploadAgainText {\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
